module.exports = __webpack_public_path__ + "assets_app/img/key_6.d89096fb.svg";